import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-aria-components';
import {
  faCheckCircle,
  faExclamationCircle,
  faClose,
  faArrowRight,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';
import { RouterLink as Link } from 'components/destiny/button/link';
import { useToasts } from 'helpers/hooks';
import styles from './index.module.scss';

type Variants = 'success' | 'error' | 'warning';

type ToastProps = {
  variant?: Variants;
  title?: string;
  message?: string;
  link?: string;
  linkText?: string;
};

const variantStyles: Record<Variants, string> = {
  success: styles.success,
  error: styles.error,
  warning: styles.warning,
};

const iconMap = {
  success: { icon: faCheckCircle },
  error: { icon: faExclamationCircle },
  warning: { icon: faExclamationTriangle },
};

export const UppToast = (props: ToastProps) => {
  const { t } = useTranslation();
  const { removeToast } = useToasts();
  const { variant, title, message, link, linkText } = props;
  const { icon } = iconMap[variant ?? 'success'];
  const variantStyle = variantStyles[variant ?? 'success'];
  const linkPresent = link && link.length > 0;

  return (
    <div className={styles.toastContainer} role="alert">
      <div className={`${styles.toast} ${variantStyle}`}>
        <div className={styles.wrapper}>
          <>
            <FontAwesomeIcon
              icon={icon}
              className={styles.variantIcon}
              aria-hidden
            />
            <div className={styles.title}>{title || message}</div>
            <Button
              onPress={removeToast}
              aria-label={t('consults.close')}
              className={styles.closeIcon}
            >
              <FontAwesomeIcon icon={faClose} aria-hidden />
            </Button>
          </>
        </div>
        {title && message && <div className={styles.text}>{message}</div>}
        {linkPresent && (
          <Link to={link!} className={styles.link} iconTrailing={faArrowRight}>
            {linkText}
          </Link>
        )}
      </div>
    </div>
  );
};
